import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-terms-of-service',
  standalone: true,
  imports: [CommonModule, RouterLink],
  template: `
    <div class="legal-page" dir="rtl">
      <header class="legal-header">
        <div class="legal-container header-inner">
          <a routerLink="/" class="back-link">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
            חזרה לאפליקציה
          </a>
          <span class="app-brand">Commpare</span>
        </div>
      </header>

      <main class="legal-container main-content">
        <article class="legal-card">
          <div class="card-badge">תנאי שימוש</div>
          <h1>תנאי שימוש – Commpare</h1>
          <p class="last-updated">עודכן לאחרונה: 14 באוקטובר 2026</p>

          <section>
            <h2>1. הסכמה לתנאים</h2>
            <p>
              השימוש באפליקציית <strong>Commpare</strong> ובשירותיה מותנה בהסכמתך לתנאי שימוש אלה. אם אינך מסכים לתנאים, הנך מתבקש להימנע משימוש באפליקציה.
            </p>
          </section>

          <section>
            <h2>2. מהות השירות</h2>
            <p>
              Commpare הינה פלטפורמה טכנולוגית להשוואת מחירי מוצרים וסלי קניות ברשתות שיווק ומזון בישראל. השירות מאפשר חיפוש מוצרים, השוואת סלי מצרכים, ניהול סלי קניות אישיים ושיתוף סלים בקבוצות.
            </p>
          </section>

          <section>
            <h2>3. מקור הנתונים ודיוק מחירים</h2>
            <p>
              נתוני המחירים, המבצעים ופרטי המוצרים מתקבלים ממאגרי המידע הפומביים שמפרסמות רשתות השיווק בהתאם לחוק קידום התחרות בענף המזון. אנו עושים מאמצים מרביים להציג נתונים עדכניים ומדויקים, אך:
            </p>
            <ul>
              <li>המחיר הקובע והמחייב הוא תמיד המחיר המוצג בקופת בית העסק או על גבי המוצר בחנות.</li>
              <li>ייתכנו שינויי מחירים תכופים, פערי עדכון, חוסרים במלאי או הבדלים בין סניפים שאינם בשליטתנו.</li>
            </ul>
          </section>

          <section>
            <h2>4. חשבונות משתמשים והתחברות Google</h2>
            <p>
              השימוש בחלק משירותי האפליקציה (כגון שמירת סלים מרובים ושיתוף קבוצתי) עשוי לדרוש התחברות באמצעות חשבון Google. הנך אחראי לשמור על אבטחת חשבונך ועל כל פעולה המבוצעת באמצעותו.
            </p>
          </section>

          <section>
            <h2>5. שימוש הוגן</h2>
            <p>
              השירות מיועד לשימוש אישי, משפחתי וצרכני הוגן. אין לבצע סריקות אוטומטיות בלתי מורשות (Scraping), התקפות עומס (DDoS), או כל פעולה העלולה לשבש את תקינות פעולת השרתים או לפגוע במשתמשים אחרים.
            </p>
          </section>

          <section>
            <h2>6. הגבלת אחריות</h2>
            <p>
              השירות מסופק "כפי שהוא" (AS IS). מפעילי Commpare אינם נושאים באחריות לכל נזק ישיר או עקיף, אי-התאמה במחירים, אובדן נתונים או שיבוש שייגרם עקב השימוש בשירות.
            </p>
          </section>

          <section>
            <h2>7. יצירת קשר</h2>
            <p>
              לשאלות, הבהרות או דיווח על תקלות, ניתן לפנות אלינו בדוא"ל:
              <a href="mailto:orenlevy9@gmail.com" class="contact-email">orenlevy9&#64;gmail.com</a>.
            </p>
          </section>

          <footer class="legal-footer">
            <p>Commpare – השוואת סלי קניות ומחירים חכמה</p>
            <div class="footer-links">
              <a routerLink="/privacy">מדיניות פרטיות</a>
              <span>•</span>
              <a routerLink="/">דף הבית</a>
            </div>
          </footer>
        </article>
      </main>
    </div>
  `,
  styles: [`
    .legal-page {
      min-height: 100vh;
      background: #f8fafc;
      color: #1e293b;
      font-family: 'Rubik', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      padding-bottom: 3rem;
    }

    .legal-header {
      background: #ffffff;
      border-bottom: 1px solid #e2e8f0;
      position: sticky;
      top: 0;
      z-index: 10;
    }

    .legal-container {
      max-width: 760px;
      margin: 0 auto;
      padding: 0 1.25rem;
    }

    .header-inner {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 60px;
    }

    .back-link {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      color: #0284c7;
      text-decoration: none;
      font-weight: 500;
      font-size: 0.95rem;
      transition: color 0.15s ease;
    }

    .back-link:hover {
      color: #0369a1;
    }

    .app-brand {
      font-size: 1.25rem;
      font-weight: 700;
      color: #0f172a;
      letter-spacing: -0.02em;
    }

    .main-content {
      margin-top: 2rem;
    }

    .legal-card {
      background: #ffffff;
      border: 1px solid #e2e8f0;
      border-radius: 16px;
      padding: 2.25rem;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.03);
    }

    .card-badge {
      display: inline-block;
      background: #f1f5f9;
      color: #475569;
      padding: 0.25rem 0.75rem;
      border-radius: 9999px;
      font-size: 0.825rem;
      font-weight: 600;
      margin-bottom: 0.75rem;
    }

    h1 {
      font-size: 1.85rem;
      font-weight: 800;
      color: #0f172a;
      margin: 0 0 0.5rem 0;
      line-height: 1.25;
    }

    .last-updated {
      color: #64748b;
      font-size: 0.9rem;
      margin-bottom: 2rem;
      padding-bottom: 1rem;
      border-bottom: 1px solid #f1f5f9;
    }

    section {
      margin-bottom: 1.75rem;
    }

    h2 {
      font-size: 1.2rem;
      font-weight: 700;
      color: #1e293b;
      margin: 0 0 0.5rem 0;
    }

    p {
      line-height: 1.65;
      color: #334155;
      margin: 0 0 0.75rem 0;
      font-size: 0.975rem;
    }

    ul {
      margin: 0.5rem 0 1rem 0;
      padding-right: 1.5rem;
      padding-left: 0;
      color: #334155;
    }

    li {
      line-height: 1.6;
      margin-bottom: 0.5rem;
      font-size: 0.975rem;
    }

    .contact-email {
      color: #0284c7;
      font-weight: 600;
      text-decoration: underline;
      direction: ltr;
      display: inline-block;
    }

    .legal-footer {
      margin-top: 2.5rem;
      padding-top: 1.5rem;
      border-top: 1px solid #e2e8f0;
      text-align: center;
      color: #64748b;
      font-size: 0.9rem;
    }

    .legal-footer p {
      margin-bottom: 0.5rem;
      color: #64748b;
    }

    .footer-links {
      display: flex;
      justify-content: center;
      gap: 0.75rem;
      align-items: center;
    }

    .footer-links a {
      color: #0284c7;
      text-decoration: none;
      font-weight: 500;
    }

    .footer-links a:hover {
      text-decoration: underline;
    }

    @media (max-width: 640px) {
      .legal-card {
        padding: 1.5rem;
        border-radius: 12px;
      }
      h1 {
        font-size: 1.5rem;
      }
    }
  `]
})
export class TermsOfServiceComponent {}
